import WorkCenter from "@/domain/maintenance/WorkCenter";
import editable from "@/domain/decorators/editable";

export default class ComponentRouteItem extends editable {
    routeItemID!: number;
    componentBomID!: number;
    cRouteItemLineNumber!: number;
    cRouteItemDescription?: string;
    cRouteItemWorkCenter!: string;
    cRouteItemAssemblyOp!: string;
    cRouteItemNumberRequired!: number;
    cRouteItemSetupTime!: number;
    cRouteItemSetupRate!: number;
    cRouteItemMachineTime!: number;
    cRouteItemMachineRate!: number;
    cRouteItemLaborTime!: number;
    cRouteItemLaborRate!: number;
    cRouteItemCycleCount!: number;
    cRouteItemText!: string;
    cRouteItemCostQty1!: number;
    cRouteItemCostQty2!: number;
    cRouteItemCostQty3!: number;
    cRouteItemCostQty4!: number;
    cRouteItemCostQty5!: number;
    cRouteItemBlankCalcDnd!: boolean;

    show = true; // used to refresh components

    //WorkCenters table
    workCenterObj!: WorkCenter;

    constructor(init?: Partial<ComponentRouteItem>) {
        super();
        Object.assign(this, init);
        if(init?.workCenterObj) {
            this.workCenterObj = new WorkCenter(init.workCenterObj);
        }
    }

    public compareTo(val: ComponentRouteItem): number {
        return this.cRouteItemLineNumber > val.cRouteItemLineNumber ? 1 :
            this.cRouteItemLineNumber === val.cRouteItemLineNumber ? 0 :
                -1;
    }

}
